import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Header from 'common/Header/Header.component';
import { Outlet } from 'react-router-dom';
import { WCThemeProvider } from 'themes';
var PublicLayout = function () {
    return (_jsxs(WCThemeProvider, { children: [_jsx(Header, { showMenu: false }), _jsx(Outlet, {})] }));
};
export { PublicLayout };
